import React, { useState, useEffect } from 'react';
import { TextField, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Avatar, Container, Button, Snackbar, Stack, Typography } from '@mui/material';
import Page from '../components/Page';
import AppsService from '../services/apps_service'
import AddSourceButton from '../sections/@dashboard/apps/AddSourceButton';

export default function SearchPage() {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchType, setSearchType] = useState('both');
    const [appData, setAppData] = useState([]);
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('us');
    const [errorText, setErrorText] = useState('');
    const [errorShow, setErrorShow] = useState(false);

    function searchApp() {
        if (searchTerm === '' | searchTerm === undefined) {
            setAppData([])
        } else {
            setAppData([]);
            AppsService.searchApp(searchTerm, searchType, selectedCountry)
                .then((response) => response.data)
                .then((data) => setAppData(data['data']))
                .catch((error) => console.log(error))
        }
    }

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            searchApp();
        }
    };

    function fetchCountries() {
        AppsService.getCountries()
            .then((response) => response.data)
            .then((data) => setCountries(data['data']))
            .catch((error) => console.log(error))
    }

    function onAppAdded() {
    }

    function onAppDeclined(error_text) {
        setErrorText(error_text)
        setErrorShow(true);
    }

    const handleErrorClose = () => {
        setErrorShow(false);
    };

    useEffect(() => {
        if (searchTerm === '' | searchTerm === undefined) {
            setAppData([])
        }
    }, [searchTerm]);

    useEffect(() => {
        fetchCountries()
    }, []);

    return (
        <Page title="Search for app">
            <Container>
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={errorShow}
                    onClose={handleErrorClose}
                    message={errorText}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={9}>
                        <TextField
                            label="Search"
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} marginTop={1}>
                        <Button variant="outlined" color="primary" onKeyPress={handleKeypress} onClick={searchApp}>Search</Button>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Select
                            label="Search Type"
                            variant="outlined"
                            fullWidth
                            value={searchType}
                            onChange={(e) => setSearchType(e.target.value)}
                        >
                            <MenuItem value="both">Both</MenuItem>
                            <MenuItem value="appstore">App Store</MenuItem>
                            <MenuItem value="googleplay">Google Play</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Select
                            label="Country"
                            variant="outlined"
                            fullWidth
                            value={selectedCountry}
                            onChange={(e) => setSelectedCountry(e.target.value)}
                        >
                            {countries.map((country) => (
                                <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell></TableCell> */}
                                        <TableCell>App Name</TableCell>
                                        <TableCell>Developer</TableCell>
                                        <TableCell>Store type</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {appData.map((app) => (
                                        <TableRow key={app.app_id}>
                                            <TableCell component="th" scope="row" padding="normal">
                                                <Stack direction="row" alignItems="center" spacing={2}>
                                                    <Avatar alt={app.app_name} src={app.avatar} />
                                                    <Typography variant="subtitle2" noWrap>
                                                        {app.app_name}
                                                    </Typography>
                                                </Stack>
                                            </TableCell>
                                            {/* <TableCell>{app.app_name}</TableCell> */}
                                            <TableCell>{app.seller_name}</TableCell>
                                            <TableCell>{app.store_type}</TableCell>
                                            <TableCell><AddSourceButton isAppAdded={app.added} appId={app.app_id} sourceType={app.store_type} country={selectedCountry} onAppAdded={onAppAdded} onAppDeclined={onAppDeclined} /></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    )
}
